/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { TableColumn } from 'src/app/shared/data-table/datasource/datasource';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  MatSelectionList,
  MatSelectionListChange,
} from '@angular/material/list';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';

type CustomizedColumns = {
  availableColumns: TableColumn<object>[];
  displayedColumns: string[];
};

@Component({
  selector: 'app-customize-columns-dialog',
  templateUrl: './customize-columns-dialog.component.html',
  styleUrls: ['./customize-columns-dialog.component.scss'],
  standalone: false
})
export class CustomizeColumnsDialogComponent {
  @ViewChild('columns') selectedColumns: MatSelectionList;

  get filteredAvailableColumns(): TableColumn<object>[] {
    return this.data.availableColumns.filter(
      (c) => !this.data.displayedColumns.includes(c.field)
    );
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CustomizedColumns,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) {}

  dropSelectedColumn(event: CdkDragDrop<unknown>) {
    if (event.container === event.previousContainer) {
      moveItemInArray(this.data.displayedColumns, event.previousIndex, event.currentIndex);
    }
  }

  onColumnSelected(event: MatSelectionListChange) {
    if (event.options[0]?.selected) {
      this.data.displayedColumns = [...this.data.displayedColumns, event.options[0].value.field];
    } else {
      this.data.displayedColumns = this.data.displayedColumns.filter((c) => c !== event.options[0].value.field);
    }
  }

  isSelected(column: TableColumn<object>) {
    return this.data.displayedColumns.includes(column.field);
  }

  getName(column: string) {
    const c = this.data.availableColumns.find((c) => c.field === column);
    return c?.localizationKey ?? c?.field;
  }

  isLocked(column: string) {
    return this.data.availableColumns.find((c) => c.field === column)?.locked;
  }
}
